// imports section Start
import React, { forwardRef, useState, useRef, useEffect } from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Dialog,
  DialogContent,
  Button,
  IconButton,
  Grid,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
import ListIcon from "@mui/icons-material/List";
import { CON_STATUS_PENDING } from "../../utils/sys/Constants";

// imports section End

const GuestCategories = forwardRef(
  (
    {
      categories = [],
      onSelectCategory,
      selectedCategory,
      onClose,
      existingCategories = [],
    },
    ref
  ) => {
    // Hooks start
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const [open, setOpen] = useState(false);
    const [tabValue, setTabValue] = useState(selectedCategory || 0);
    const containerRef = useRef(null);
    const buttonRefs = useRef({});

    useEffect(() => {
      scrollToSelected();
    }, [tabValue]);
    // Hooks end

    // Handlers start
    const handleOpen = () => setOpen(true);

    const handleClose = () => {
      setOpen(false);
      if (onClose) onClose();
    };

    const handleSelect = (category) => {
      onSelectCategory(category);
      setTabValue(category.MENUCATCODE);
      handleClose();
    };

    const removeDuplicates = (arr) => {
      const seen = new Set();
      return arr.filter((item) => {
        const duplicate = seen.has(item.MENUCATCODE);
        seen.add(item.MENUCATCODE);
        return !duplicate;
      });
    };

    const uniqueCategories = removeDuplicates(categories);
    const scrollLeft = () => {
      if (containerRef.current) {
        containerRef.current.scrollBy({ left: -100, behavior: "smooth" });
      }
    };

    const scrollRight = () => {
      if (containerRef.current) {
        containerRef.current.scrollBy({ left: 100, behavior: "smooth" });
      }
    };

    const scrollToSelected = () => {
      const button = buttonRefs.current[tabValue];
      if (button && containerRef.current) {
        button.scrollIntoView({
          behavior: "smooth",
          inline: "center",
        });
      }
    };
    // Handlers end

    return (
      <Box sx={{}} paddingX={4}>
        {/* <Card> */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            alignItems: "center",
            // alignSelf: "center",
            position: "relative",

            borderRadius: 0,
            py: 1,
            mx: 2,
            gap: 2,
            backgroundColor: theme.palette.background.paper,
          }}
        >
          <IconButton
            onClick={handleOpen}
            sx={{
              borderRadius: 0,
              // boxShadow: 1,
              // backgroundColor: theme.palette.background.fill,
              fontSize: theme.typography.sub_title,
              // fontWeight: 500,
              color: theme.palette.text.primary,
              gap: 1,
            }}
          >
            <ListIcon />
            {!isMobile && "Menu"}
          </IconButton>
          <Box
            ref={containerRef}
            sx={{
              // display: "flex",
              flexDirection: "row",
              flexWrap: "nowrap",
              overflowX: "auto",
              whiteSpace: "nowrap",
              justifyContent: "center",
              alignContent: "center",
              gap: "8px",
              py: "2px",
              px: 2,
              // boxShadow: 1,
              // backgroundColor: theme.palette.background.fill,
              borderBottom: `2px solid ${theme.palette.text.tertiary}`,
              scrollbarWidth: "none",
              "&::-webkit-scrollbar": {
                display: "none",
              },
              // flex: 1,
            }}
          >
            {uniqueCategories.map((category) => (
              <Button
                key={category.MENUCATCODE}
                onClick={() => handleSelect(category)}
                variant={
                  tabValue === category.MENUCATCODE ? "contained" : "outlined"
                }
                ref={(el) => (buttonRefs.current[category.MENUCATCODE] = el)}
                sx={{
                  px: isMobile ? 2 : 4,
                  // boxShadow: 1,

                  borderRadius: "0px",
                  textTransform: "none",
                  // color: theme.palette.text.primary,
                  // margin: "0 4px",
                  border: 0,
                  // borderBottom: `0px solid ${theme.palette.text.tertiary}`,
                  backgroundColor: category.CATSTS===CON_STATUS_PENDING?"#D27804":"",
                  color: theme.palette.text.primary,
                  ...(tabValue === category.MENUCATCODE
                    ? {
                        backgroundColor: theme.palette.primary.main,
                        color: theme.palette.text.buttontxt,
                      }
                    : {}),
                }}
              >
                {category.MENUCATNAME}
              </Button>
            ))}
          </Box>
          <Box sx={{ display: "flex", gap: 1, py: "2px" }}>
            {!isMobile && (
              <IconButton
                onClick={scrollLeft}
                sx={{
                  borderRadius: 50,
                  boxShadow: `0px 0px 2px 0px ${theme.palette.input_field.stroke}`,
                  right: 0,
                  zIndex: 1,
                  backgroundColor: theme.palette.background.tertiary,
                  color: theme.palette.text.primary,
                }}
              >
                <ArrowBackIcon />
              </IconButton>
            )}
            {!isMobile && (
              <IconButton
                onClick={scrollRight}
                sx={{
                  borderRadius: 50,
                  boxShadow: `0px 0px 2px 0px ${theme.palette.input_field.stroke}`,
                  // boxShadow: 1,
                  right: 0,
                  zIndex: 1,
                  backgroundColor: theme.palette.background.tertiary,
                  color: theme.palette.text.primary,
                }}
              >
                <ArrowForwardIcon />
              </IconButton>
            )}
          </Box>{" "}
        </Box>
        {/* </Card> */}
        <Dialog open={open} onClose={handleClose} fullScreen={isMobile}>
          <DialogContent
            sx={{
              display: "flex",
              flexDirection: "column",
              backgroundColor: theme.palette.background.default,
              padding: "1rem",
              position: "relative",
            }}
          >
            {/* Close Button */}
            <IconButton
              onClick={handleClose}
              sx={{ position: "absolute", top: "1rem", right: "1rem" }}
            >
              <CloseIcon />
            </IconButton>

            {/* Title */}
            <Typography
              variant="h6"
              sx={{
                color: theme.palette.text.primary,
                fontWeight: "bold",
                textAlign: "left",
                marginBottom: "1rem",
              }}
            >
              Menu
            </Typography>

            <Box sx={{ flex: 1, overflowY: "auto", p: 2 }}>
              <Grid container spacing={2}>
                {removeDuplicates(existingCategories).map((category) => (
                  <Grid item xs={12} sm={6} md={4} key={category.MENUCATCODE}>
                    <Box
                      onClick={() => handleSelect(category)}
                      sx={{
                        padding: "0.8rem",
                        backgroundColor: theme.palette.background.paper,
                        borderRadius: "4px",
                        boxShadow: theme.shadows[1],
                        cursor: "pointer",
                        ...(selectedCategory === category.MENUCATCODE
                          ? {
                              backgroundColor: theme.palette.primary.light,
                              color: theme.palette.text.buttontxt,
                            }
                          : {}),
                        // "&:hover": {
                        //   backgroundColor: theme.palette.background.default,
                        // },
                      }}
                    >
                      <Typography variant="body1">
                        {category.MENUCATNAME}
                      </Typography>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </DialogContent>
        </Dialog>
      </Box>
    );
  }
);

export default GuestCategories;
